import * as React from 'react'

import { MenuDivider, MenuGroup, MenuGroupHeader, MenuItemRadio, MenuList, MenuPopover } from '@fluentui/react-components'

import { SORT_BY_OPTIONS, SORT_ORDER_OPTIONS } from '../constants/sort-menu'

const SortMenuPopover = (props) => {
  const { sortBy } = props
  return (
    <MenuPopover>
      <MenuList>
        <MenuGroup>
          <MenuGroupHeader>Sort by</MenuGroupHeader>
          {SORT_BY_OPTIONS.map((option) => (
            <MenuItemRadio
              key={option.value}
              name='sortBy'
              value={option.value}
            >
              {option.label}
            </MenuItemRadio>
          ))}
        </MenuGroup>
        <MenuDivider />
        <MenuGroup>
          <MenuGroupHeader>Sort order</MenuGroupHeader>
          {SORT_ORDER_OPTIONS[sortBy].map((option) => (
            <MenuItemRadio
              key={option.value}
              name='sortOrder'
              value={option.value}
            >
              {option.label}
            </MenuItemRadio>
          ))}
        </MenuGroup>
      </MenuList>
    </MenuPopover>
  )
}

export default SortMenuPopover
